import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CategoryState } from "../reducers" 

export const selectCategoryState = createFeatureSelector<CategoryState>('category');

export const selectCategoryLoading = createSelector(
  selectCategoryState,
  (state: CategoryState) => state.loading
);

export const selectCategoryList = createSelector(
  selectCategoryState,
  (state: CategoryState) => state.categoryList
);

export const selectCategoryError = createSelector(
  selectCategoryState,
  (state: CategoryState) => state.error
);
